import { useLocation } from "react-router-dom";
import { contact } from "@/config/site";
import { getServiceBySlug } from "@/config/services";
import { waMessages } from "@/lib/whatsapp";
import WhatsAppLink from "@/components/feature/WhatsAppLink";

export default function MobileActionBar() {
  const location = useLocation();
  const match = location.pathname.match(/^\/hizmetler\/([^/]+)/);
  const service = match ? getServiceBySlug(match[1]) : undefined;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-background-300/60 bg-background-100 px-3 pt-2 pb-[calc(0.5rem+env(safe-area-inset-bottom))] md:hidden">
      <div className="grid grid-cols-2 gap-2">
        <a
          href={contact.phoneHref}
          className="inline-flex items-center justify-center gap-2 rounded-md border border-primary-800 py-3 text-sm font-medium text-primary-800 transition-colors hover:bg-primary-800 hover:text-background-50"
        >
          <i className="ri-phone-line text-lg" aria-hidden="true"></i>
          Ara
        </a>
        {service ? (
          <WhatsAppLink
            message={waMessages.serviceInfo(service.name)}
            label="Bu İşlemi Sor"
            variant="whatsapp"
            size="md"
            sourceSection="mobile_bar"
            serviceId={service.id}
            className="w-full"
          />
        ) : (
          <WhatsAppLink
            message={waMessages.general}
            label="WhatsApp'tan Yazın"
            variant="whatsapp"
            size="md"
            sourceSection="mobile_bar"
            className="w-full"
          />
        )}
      </div>
    </div>
  );
}